import { RefObject, useEffect, useState } from 'react';

import { Metrics } from '../EBarChart';

export function useCalculateChartWidth(
  containerRef: RefObject<HTMLDivElement>,
  metrics: Metrics[],
  options: {
    minWidth: number;
  } = {
    minWidth: 400,
  }
) {
  // const barWidth = 8;
  const metricsWidth = metrics.length * 56;
  const [chartWidth, setChartWidth] = useState(() => {
    return Math.max(metricsWidth, options.minWidth);
  });

  useEffect(() => {
    // 컨테이너의 너비를 측정하여 상태로 설정
    if (containerRef.current) {
      setChartWidth(Math.max(metricsWidth, containerRef.current.clientWidth));
    }

    const handleResize = () => {
      if (containerRef.current) {
        setChartWidth(Math.max(metricsWidth, containerRef.current.clientWidth));
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [metrics]);

  return {
    chartWidth,
  };
}
